import { PressureUnit } from '@app/shared/units/pressure/pressure-unit.enum';

/**
 * Relative to 1 bar.
 *
 * The two head units use the conventional freshwater column at 4 °C (1 mH2O = 0.0980665 bar), so a
 * value entered as metres head round-trips to the same number it came from.
 */
export const pressureFactors: Record<PressureUnit, number> = {
  [PressureUnit.Bar]: 1,
  [PressureUnit.Kilopascal]: 0.01,
  [PressureUnit.Psi]: 0.0689476,
  [PressureUnit.MetresHead]: 0.0980665,
  [PressureUnit.FeetHead]: 0.0298907,
};
